import { render } from "./ChoixDePopulation.vue?vue&type=template&id=736f36ea&scoped=true"
import script from "./ChoixDePopulation.vue?vue&type=script&lang=js"
export * from "./ChoixDePopulation.vue?vue&type=script&lang=js"

import "./ChoixDePopulation.vue?vue&type=style&index=0&id=736f36ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736f36ea"]])

export default __exports__